import React, { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';

import { useCurrentAddressInfo } from '@/hooks';
import { isLogout } from '@/utils';

export const NeedLogin = ({ children }: { children: ReactElement }) => {
  const { isVerified } = useCurrentAddressInfo();

  if (isVerified) {
    return children;
  }

  return (
    <Redirect
      to={{
        pathname: '/',
        state: {
          // 如果是主动 logout 的，不记录当前的页面链接了
          // 如果是外部点过来的，就记录
          wantedLocation: isLogout ? '' : window.location.href.slice(window.location.origin.length),
        },
      }}
    />
  );
};
